<template>
  <div class="membership-selected">
    {{ fee ? fee.title : membershipType }}
    <span />
  </div>
</template>

<script>
import { registrationConfig } from "../helpers/config";
import { useMemberDetails } from "../helpers/member-details";

export default {
  setup() {
    const { membershipType, membershipStatusType } = useMemberDetails();

    const fee = registrationConfig.fees.find(
      (f) =>
        f.memTypeCode === membershipType.value &&
        f.memStatusCode ===
          (membershipStatusType.value === "NP1" ||
          membershipStatusType.value === "NP2"
            ? "ORD"
            : membershipStatusType.value),
    );

    return {
      membershipType,
      fee,
    };
  },
};
</script>
